export default __webpack_public_path__ + "static/media/Asset 11.10e032bb.png";